import { ClockCircleOutlined, DeleteOutlined, DownloadOutlined, ExclamationCircleOutlined, PlayCircleOutlined ,FileDoneOutlined } from "@ant-design/icons";
import { Button, DatePicker, message, Pagination, Space, Table, Tooltip } from "antd";
import Input from "antd/es/input/Input";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkCaseStartStatus, deleteCaseStartReport, downloadCaseStartReport, getCaseStartReport, startCaseStartService, uploadCaseStartReport } from "../../apis/CaseStartAPI";
import "../../assets/styles/pageStyle.scss";
import InfoDialog from "../../components/InfoDialog";
import PageTour from "../../components/PageTour/PageTour";
import { formatDateToYYYYMMDD } from "../../libs/utilities/helpers/dateFormatter";
import { calculatePageSize } from "../../libs/utilities/helpers/paginationHelper";
import { hideInfoDialog, showInfoDialog } from "../../reducers/infoDialogSlice";
import { toggleTour } from "../../reducers/tourSlice";
import UploadMedia from "./components/UploadMedia";
import { useLocation } from "react-router-dom"; 
import {getTitleFromPath} from "../../libs/utilities/helpers/getTitle"
const { RangePicker } = DatePicker;

const CaseStart = () => {
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState('');
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(false);
    const [allReport, setAllReport] = useState([]);
    const [filteredReport, setFilteredReport] = useState([]);
    const [filteredReportWithoutSort, setFilteredReportWithoutSort] = useState([]);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState([]);
    const [serviceStatusLoading, setServiceStatusLoading] = useState(true);
    const [serviceRunning, setServiceRunning] = useState(false);
    const [allserviceCompleted,setAllserviceCompleted]=useState(false);
    const [verifyReportCall,setVerifyReportCall]=useState(true)
  const location = useLocation();
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 3,
        total: 0
    })

    const [dateRange, setDateRange] = useState({
        startDate: '',
        endDate: '',
    })

    const dateFormat = 'YYYY-MM-DD';
    const defaultDateRange = [
        dayjs().subtract(6, 'days'),
        dayjs()
    ];

    const columns = [
        {
            title: 'Name',
            dataIndex: 'document_name',
            key: 'document_name',
            sorter: (a, b) => { }
        },
        {
            title: 'Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
        },
        {
            title: 'Status',
            dataIndex: 'is_processed',
            key: 'is_processed',
            render: (_, record) => (
                <> {record.is_processed ? <div style={{ color: "" }}>Completed</div> : <div style={{ color: "" }}>In Progress</div>} </>
            )
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="small">
                    {
                        record.is_processed ?
                            <Button type="text"
                                loading={selectedDocument.some(item => item === record.document_name) &&
                                    downloadLoading} onClick={() => downloadCaseStartReport(record.document_name, record.document_id)}
                            >
                                <DownloadOutlined />
                            </Button> :
                            <Tooltip title="Document not generated">
                                <Button type="text"><ExclamationCircleOutlined style={{ color: "gray" }} /></Button>
                            </Tooltip>
                    }
                    <Tooltip title="Delete document">
                        <Button onClick={() => startDocumentDelete(record.document_id)} type="text">
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </Space>
            ),
        },
    ];

    useEffect(() => {
        //console.log("in useeffect")
        const startDate = formatDateToYYYYMMDD(dayjs().subtract(6, 'days'));
        const endDate = formatDateToYYYYMMDD(dayjs());
        verifyStatus();
        const interval = setInterval(() => {
            verifyStatus();
        }, 60 * 10 * 10 * 10); //Check the status every minutes (60 seconds)
        setDateRange({ startDate, endDate })
        getReport(startDate, endDate)
        // eslint-disable-next-line

        window.addEventListener('resize', handleResize);
        return () => {
            clearInterval(interval);
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const handleResize = () => {
        calculatePageSize(setPagination);
    }

    const [selectedDocumentIdToDelete, setSelectedDocumentIdToDelete] = useState();

    const startDocumentDelete = (doc_id) => {
        setSelectedDocumentIdToDelete(doc_id);
        dispatch(showInfoDialog({ title: "Are you sure you want to delete?", description: "" }));
    }

    const confirmDocumentDelete = async () => {
        try {
            const response = await dispatch(deleteCaseStartReport({ _id: selectedDocumentIdToDelete }))
            if (!response.error) {
                message.success("File deleted successfully");
                dispatch(hideInfoDialog());
                getReport(dateRange.startDate, dateRange.endDate)
            }
        } catch (e) {
            message.warning("Something went wrong!");
        }
    }

    const getReport = async (startDate, endDate) => {
        //console.log("in get Report")
        setFetchLoading(true);
        const response = dispatch(getCaseStartReport({ startDate, endDate }));
        const data = await response;
        if (!data.error) {
            setSearchText('');
            // {document_name, is_processed, createdAt, updatedAt}
            const sortedData = data.payload.data.documents.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
            const lists = sortedData.map((item, index) => (
                {
                    id: index,
                    document_id: item._id,
                    document_name: item.document_name,
                    is_processed: item.is_processed,
                    createdAt: formatDateToYYYYMMDD(item.createdAt), updatedAt: item.updatedAt
                }));

                const allProcessed = sortedData.every(doc => doc.is_processed === true);
                if (allProcessed == false) {
                    setServiceRunning(false);
                    setAllserviceCompleted(false)
                } else {
                    setAllserviceCompleted(true);
                    setServiceRunning(true);
                    setVerifyReportCall(false)
 
                }
            setPagination({ ...pagination, total: lists.length })
            setAllReport(lists);
            setFilteredReport(lists);
            setFilteredReportWithoutSort([...lists]);
            handleResize();
        }
        setFetchLoading(false);
    }

    const handleDateFilter = (dates, dateStrings) => {
        if (!dates) {
            return;
        }
        let startDate = formatDateToYYYYMMDD(dateStrings[0]);
        let endDate = formatDateToYYYYMMDD(dateStrings[1]);
        setDateRange({ startDate, endDate })
        getReport(startDate, endDate);
    };

    const [tableSorter, setTableSorter] = useState(null);

    const sortTableData = (pagination, filters, sorter) => {
        setTableSorter(sorter);
        if (sorter.columnKey === "document_name") {
            if (!sorter.order) {
                setFilteredReport(filteredReportWithoutSort);
                return;
            }
            const filtered = filteredReport.sort((a, b) =>
                sorter.order === "ascend" ? a.document_name.localeCompare(b.document_name) : b.document_name.localeCompare(a.document_name));
            setFilteredReport([...filtered]);
        }
    }

    const handlePageChange = (page, pageSize) => {
        setPagination({ ...pagination, current: page, pageSize })
    }

    const startIdx = (pagination.current - 1) * pagination.pageSize;
    const endIdx = startIdx + pagination.pageSize;
    const displayData = filteredReport.slice(startIdx, endIdx);
    const getEndOfDay = (date) => {
        const endOfDay = new Date(date);
        endOfDay.setHours(23, 59, 59, 999);
        return endOfDay;
    };

    const disabledDate = current => {
        return current && current > getEndOfDay(new Date());
    };

    function replaceExtension(filename) {
        const lastDotIndex = filename.lastIndexOf('.xlsx');
        if (lastDotIndex !== -1) {
            return filename.slice(0, lastDotIndex) + '.docx';
        }
        // If ".xlsx" is not found, return the original filename
        return filename;
    }

    const downloadCaseStartReport = async (document_name, document_id) => {
        setSelectedDocument([...selectedDocument, document_name]);
        setDownloadLoading(true);
        try {
            const response = await dispatch(downloadCaseStartReport({ "_id": document_id }));
            if (!response.error) {
                const binaryString = atob(response.payload.data);
     
                const arrayBuffer = new ArrayBuffer(binaryString.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryString.length; i++) {
                    uint8Array[i] = binaryString.charCodeAt(i);
                }
     
                // Create a Blob with the appropriate content type for a zip file
                const blob = new Blob([arrayBuffer], { type: 'application/zip' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const filenameWithZipExtension = document_name.replace(/\.xlsx$/i, '.zip');
                link.setAttribute('download', filenameWithZipExtension);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
     
        } catch (e) {
            message.error('Failed to download report. Please try again.');
        } finally {
            setSelectedDocument((prev) => prev.filter(item => item !== document_name));
            setDownloadLoading(false);
        }
    }
const hasInvalidChars = (value) => {
    return /[<>/"'`;()&*#$%!^?]/.test(value);
};
    const handleSearch = (e) => {
        const searchString = e.target.value;
         if (hasInvalidChars(searchString)) {
            message.destroy();
            message.error('Special characters are not allowed');
        return;
        }
        setSearchText(searchString);
        const allData = [...allReport];
        const filtered = allData.filter(item => item.document_name.toLowerCase().includes(searchString.trim().toLowerCase()))
        setPagination({ ...pagination, current: 1, pageSize: 3, total: filtered.length })

        setFilteredReport(filtered);
        setFilteredReportWithoutSort([...filtered]);

        if (tableSorter?.columnKey === "document_name") {
            if (!tableSorter.order) {
                setFilteredReport(filteredReportWithoutSort);
                return;
            }
            const tempFiltered = filtered.sort((a, b) =>
                tableSorter.order === "ascend" ? a.document_name.localeCompare(b.document_name) : b.document_name.localeCompare(a.document_name));
            setFilteredReport([...tempFiltered]);
        }

    }

    const handleFileSelect = (file) => {
        setFileList(file)
    };

    const generateReport = async () => {
        if (fileList.length === 0) {
            message.warning("Please upload a file")
            return;
        }
        setLoading(true);
        try {
            const data = {
                file: fileList[0],
                type: "xlsx"
            }
            const response = await dispatch(uploadCaseStartReport(data));
            if (!response.error) {
                message.success("File uploaded successfully. File will display in the table after process completion")
                setFileList([])
                getReport(dateRange.startDate, dateRange.endDate);
            }
        } catch (e) {

        } finally {
            setLoading(false);
        }
    }

    const tourState = useSelector((state) => state.tour);
    const handleTourClose = () => {
        dispatch(toggleTour({ show: false }))
      
    }

    const startService = async () => {
        setServiceStatusLoading(true);
        await dispatch(startCaseStartService());
        verifyStatus();
    }

    const verifyStatus = async () => {
        const response = await dispatch(checkCaseStartStatus());
        if (response.payload?.data?.running_task_ids?.length > 0) {
            setServiceRunning(true);
            setAllserviceCompleted(false)
        } else {
            setServiceRunning(false);
            if(verifyReportCall){
                setVerifyReportCall(false);
                const formattedDates = defaultDateRange.map(dateStr => {
                    const date = new Date(dateStr);
                    return date.toISOString().split('T')[0];
                });
                getReport(formattedDates[0], formattedDates[1])
            }
           
        }
        setServiceStatusLoading(false);
    }
 

    return (
        <>
        <div className="heading-div">
        <p className="text5">
          {getTitleFromPath(location ?.pathname)}
        </p>
      </div>
            <div className="case-start-container">
                <InfoDialog onConfirm={confirmDocumentDelete} />
                <PageTour show={tourState.show} handleShow={handleTourClose} target="ant-upload-drag" title="Start uploading excel file to get transcript report" />
                <div className="file-table">
                    <div className="table-actions">
                        <Input size="middle" value={searchText} onChange={(e) => handleSearch(e)} placeholder="Search" />
                        <div style={{display:"flex"}}>
                            <RangePicker
                                className="file-datepicker"
                                onChange={handleDateFilter}
                                disabledDate={disabledDate}
                                defaultValue={defaultDateRange}
                                format={dateFormat}
                                allowClear={false}
                            />
                           <div>
                                <Tooltip title={serviceRunning ? (allserviceCompleted ? "Completed":"Running") : "Run All"}>
                                    <Button style={{ marginLeft: "1rem", height: "30px" }} onClick={startService} size="middle" shape="circle" disabled={serviceRunning || !displayData.length} icon={serviceRunning ? ( allserviceCompleted ? <FileDoneOutlined/>:<ClockCircleOutlined />) : <PlayCircleOutlined />} loading={serviceStatusLoading} />
                                </Tooltip>
                            </div>
 
                        </div>
                    </div>

                    <Table
                        columns={columns}
                        dataSource={displayData}
                        loading={fetchLoading}
                        style={{ overflowY: "auto" }}
                        pagination={false}
                        rowKey={(record) => record.id}
                        onChange={sortTableData}
                    />
                    <Pagination
                        current={pagination.current}
                        pageSize={pagination.pageSize}
                        total={+pagination.total}
                        onChange={handlePageChange} style={{ marginTop: "5px", float: "right" }} />

                </div>
               
                <div>
                    <UploadMedia
                        handleFileSelect={handleFileSelect}
                        fileList={fileList}
                        handelClick={generateReport}
                        disabled={loading}
                    />
                  
                </div>
            </div>
        </>
    )
}

export default CaseStart;
